import { PhoneCall, AlertTriangle } from "lucide-react"
import { cn } from "@/lib/utils"
import { useCallQuota } from "../hooks/useCallQuota"

function formatResetTime(resetsAt: string | null): string | null {
  if (!resetsAt) return null
  const date = new Date(resetsAt)
  return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
}

export function AiCallQuotaMeter() {
  const { data: quota, isLoading } = useCallQuota()

  if (isLoading || !quota) return null

  const isExhausted = quota.remaining === 0
  const resetTime = formatResetTime(quota.resetsAt)

  return (
    <div
      className={cn(
        "flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-xs font-medium",
        isExhausted
          ? "border-amber-200 bg-amber-50 text-amber-700 dark:border-amber-400/20 dark:bg-amber-400/10 dark:text-amber-300"
          : "border-border bg-card text-muted-foreground",
      )}
      title="AI screening calls remaining in the current 1-hour window"
    >
      {isExhausted ? (
        <AlertTriangle className="h-3.5 w-3.5" />
      ) : (
        <PhoneCall className="h-3.5 w-3.5" />
      )}
      <span>
        {quota.remaining} / {quota.limit} calls remaining
        {resetTime ? ` · resets ${resetTime}` : ""}
      </span>
    </div>
  )
}
